import React, { useEffect } from 'react'
import { Checkbox, Radio } from '@mds/mds-reactjs-library'

/** Pixels of left padding per tree depth; must match CollapsibleAttributeTree so parent/leaf rows align. */
export const TREE_LEVEL_INDENT_PX = 20

export const AttributeComment = ({ showDefinition, comment }) =>
  showDefinition && comment && comment !== 'NA' ? <p className="comment">{comment}</p> : null

export const TreeNodeInfo = ({
  displayName,
  nameSuffix,
  showDefinition,
  comment,
  tabIndex,
  onClick,
  onKeyDown,
}) => (
  <div className="info" tabIndex={tabIndex} onKeyDown={onKeyDown} onClick={onClick}>
    <p className="attribute-name">
      {displayName}
      {nameSuffix}
    </p>
    <AttributeComment showDefinition={showDefinition} comment={comment} />
  </div>
)

export const TreeCheckboxCell = ({ className, checked, item, onItemClick }) => (
  <div className="tree-selector-cell">
    <Checkbox
      className={className}
      checked={checked}
      value=""
      item={item}
      onClick={() => onItemClick(item)}
    />
  </div>
)

export const TreeRadioCell = ({ className, checked, onItemClick, item }) => (
  <div className="tree-selector-cell">
    <Radio
      className={className}
      value=""
      checked={checked}
      label=""
      onClick={() => onItemClick(item)}
    />
  </div>
)

/** Leaf row: tree-gutter (aligns with parent expand column) + info + optional Radio or Checkbox. */
export const AttributeLeafRow = ({
  item,
  showItem,
  showDefinition,
  isPlaceholder,
  checkBoxClicked,
  isSelected,
  variant,
  radioClassName,
  checkboxClassName,
  /** 0 = root; must match parent rows that use `level` in CollapsibleAttributeTree (overrides .flex left padding). */
  level = 0,
}) => {
  if (!showItem(item)) return null
  const placeholder = isPlaceholder(item)
  const rowStyle = { paddingLeft: level * TREE_LEVEL_INDENT_PX }
  return (
    <div className="flex" style={rowStyle}>
      <div className="tree-gutter" aria-hidden="true" />
      <TreeNodeInfo
        tabIndex={placeholder ? -1 : 0}
        onKeyDown={placeholder ? undefined : (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            checkBoxClicked(item)
          }
        }}
        onClick={() => { !placeholder && checkBoxClicked(item) }}
        displayName={item.DisplayName}
        nameSuffix={null}
        showDefinition={showDefinition}
        comment={item.Comment}
      />
      {!placeholder && variant === 'radio' && (
        <TreeRadioCell
          className={radioClassName}
          checked={isSelected(item)}
          item={item}
          onItemClick={checkBoxClicked}
        />
      )}
      {!placeholder && variant === 'checkbox' && (
        <TreeCheckboxCell
          className={checkboxClassName}
          checked={isSelected(item)}
          item={item}
          onItemClick={checkBoxClicked}
        />
      )}
    </div>
  )
}

export function useSyncChildrenVisibilityForSearch(searchTerm) {
  useEffect(() => {
    const childrenElements = document.querySelectorAll('.children')
    if (searchTerm !== undefined && searchTerm.trim() !== '') {
      childrenElements.forEach((element) => {
        element.classList.replace('hideChildren', 'showChildren')
      })
    } else {
      childrenElements.forEach((element) => {
        element.classList.replace('showChildren', 'hideChildren')
      })
    }
  }, [searchTerm])
}
